module.exports = require("file-type");